<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>

        <template v-if="breakpoint != 'sm'">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul class="vx-navbar__starred-pages">
            <draggable
              v-model="starredPagesLimited"
              :group="{ name: 'pinList' }"
              class="flex cursor-move"
            >
              <li
                class="starred-page"
                v-for="page in starredPagesLimited"
                :key="page.url"
              >
                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                  <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="page.labelIcon"
                    @click="$router.push(page.url)"
                  ></feather-icon>
                </vx-tooltip>
              </li>
            </draggable>
          </ul>

          <div class="bookmark-container" v-if="breakpoint != 'md'">
            <img :src="logo" v-if="logo" height="40" />
          </div>
          <!-- <div class="bookmark-container">
            <a
              href="http://evosolucoes.com/evoOS/client/evo/"
              target="_blank"
              class="link-help"
            >
              <feather-icon
                icon="HelpCircleIcon"
                :svgClasses="[
                  'stoke-current ',
                  { 'text-white': navbarColor != '#fff' },
                ]"
                class="cursor-pointer"
              />
              <span class="text">Help Desk</span></a
            >
          </div> -->

          <!-- <div class="selectEmpresa" v-if="listEmpresa.length > 0">
            <select name="selectEmpresa" @change="selectedEmpresa">
              <option
                v-for="(empresa, index) of listEmpresa"
                :key="index"
                :value="empresa.id_empresa"
                :selected="idEmpresaCurrent === empresa.id_empresa"
              >
                {{ empresa.nome }}
              </option>
            </select>
          </div> -->

          <div
            class="changeEmpresa"
            :style="{
              'background-color': this.corEmpresa
                ? this.corEmpresa.botaoLogin
                : '#2596BE',
            }"
            v-if="listEmpresa.length > 1"
          >
            <div
              @click="getNomeCurrentEmpresa, (isModalOpenChangeEmpresa = true)"
            >
              <strong v-if="breakpoint != 'md'">Empresa atual:</strong>
              <span class="text-ellipsis"> {{ getNomeCurrentEmpresa() }}</span>
            </div>
            <button
              @click="getNomeCurrentEmpresa, (isModalOpenChangeEmpresa = true)"
            >
              <feather-icon
                icon="RepeatIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
            </button>
          </div>

          <!-- STARRED PAGES MORE
          <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{name: 'pinList'}"
                    class="cursor-move"
                  >
                    <li
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url)"
                    >
                      <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <div class="bookmark-container">
            <feather-icon
              icon="StarIcon"
              :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]"
              class="cursor-pointer p-2"
              @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown"
            />
            <div
              v-click-outside="outside"
              class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4"
              v-if="showBookmarkPagesDropdown"
            >
              <vx-auto-suggest
                :autoFocus="true"
                :data="navbarSearchAndPinList"
                @selected="selected"
                @actionClicked="actionClicked"
                inputClassses="w-full"
                show-action
                show-pinned
                background-overlay
              ></vx-auto-suggest>
            </div>
          </div>-->
        </template>

        <vs-spacer></vs-spacer>

        <!-- SEARCHBAR
        <div
          class="search-full-container w-full h-full absolute left-0 rounded-lg"
          :class="{'flex': showFullSearch}"
          v-show="showFullSearch"
        >
          <vx-auto-suggest
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            @selected="selected"
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            placeholder="Search..."
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border"
            icon="SearchIcon"
            background-overlay
          ></vx-auto-suggest>
          <div class="absolute right-0 h-full z-50">
            <feather-icon
              icon="XIcon"
              class="px-4 cursor-pointer h-full close-search-icon"
              @click="showFullSearch = false"
            ></feather-icon>
          </div>
        </div>
        <feather-icon
          icon="SearchIcon"
          @click="showFullSearch = true"
          class="cursor-pointer navbar-fuzzy-search ml-4"
        ></feather-icon>
        -->
        <!-- NOTIFICATIONS
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer ml-4">
          <feather-icon
            icon="BellIcon"
            class="cursor-pointer mt-1 sm:mr-6 mr-2"
            :badge="unreadNotifications.length"
          ></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
              <p class="opacity-75">App Notifications</p>
            </div>

            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
              :settings="settings"
            >
              <ul class="bordered-items">
                <li
                  v-for="ntf in unreadNotifications"
                  :key="ntf.index"
                  class="flex justify-between px-4 py-4 notification cursor-pointer"
                >
                  <div class="flex items-start">
                    <feather-icon
                      :icon="ntf.icon"
                      :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"
                    ></feather-icon>
                    <div class="mx-2">
                      <span
                        class="font-medium block notification-title"
                        :class="[`text-${ntf.category}`]"
                      >{{ ntf.title }}</span>
                      <small>{{ ntf.msg }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.time) }}</small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
            >
              <span>View All Notifications</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        -->
        <!-- USER META -->
        <div class="profile_and_notification">
          <div class="fab_with_Badge" v-if="verificaBemProtege()">
            <div class="notification" @click.stop.prevent="showNotifications">
              <vs-icon
                class="text-3xl"
                icon-pack="feather"
                icon="icon-bell"
                color="white"
              ></vs-icon>
            </div>
            <div class="badge" v-if="notificationCount > 0">
              <div class="content">
                <span
                  class="number-notification"
                  v-if="notificationCount > 0"
                  >{{ notificationCount }}</span
                >
              </div>
            </div>
            <div v-if="notificationsVisible" class="dropdown">
              <div class="drop-notificacoes">
                <p>Atualizações</p>
                <div class="badge-dropdown" v-if="notificationCount > 0">
                  <div class="badge-dropdown-content">
                    <span
                      class="number-notification-dropdown"
                      v-if="notificationCount > 0"
                      >{{ notificationCount }}</span
                    >
                  </div>
                </div>
              </div>
              <vs-collapse class="collapse-div w-full p-0">
                <vs-collapse-item
                  v-for="(note, index) in atualizationNotes"
                  :key="index"
                >
                  <div
                    class="flex items-center justify-between mr-5 gap-3"
                    slot="header"
                  >
                    <p
                      class="text-Text-Variant font-montserrat text-sm font-normal line-normal"
                    >
                      {{ note.tituloNota }} - {{ note.resumoNota }}
                    </p>
                    <div>
                      <p
                        class="text-Text text-center font-montserrat text-xs font-normal"
                      >
                        {{ decreaseThreeHours(note.updatedAt) }}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p class="text-collapse-notes">
                      {{ note.descricaoNota }}
                    </p>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>
          </div>
          <div class="the-navbar__user-meta flex items-center">
            <div class="text-right leading-tight hidden sm:block">
              <p class="text-Text font-montserrat text-base font-medium">
                {{ this.$store.state.nomeCurrentUsuario }}
              </p>
            </div>
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="cursor-pointer"
            >
              <div class="con-img ml-3">
                <img
                  v-if="activeUserImg.startsWith('http')"
                  key="onlineImg"
                  :src="activeUserImg"
                  alt="user-img"
                  width="40"
                  height="40"
                  class="rounded-full shadow-md cursor-pointer block"
                />
                <div v-else alt="user-img" class="notification">
                  <vs-icon
                    class="text-3xl"
                    icon-pack="feather"
                    icon="icon-user"
                    color="white"
                  ></vs-icon>
                </div>
                <!-- <img
                  v-else
                  key="localImg"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAMAAADQfiliAAAAYFBMVEVPT0/////w8PAxMTFERERAQEBKSkpHR0fj4+M9PT3d3d26urqVlZX7+/tTU1PNzc2rq6ujo6NeXl5ZWVl1dXXX19ebm5s2NjbFxcV/f39ra2uFhYXq6uplZWWMjIy0tLR0Q7UjAAAFvUlEQVR4nM2c2baqMAyGS22LiCAzOIDv/5a7gCBCh4QNS/+7s84q/eyQJmm6ibNG9HTx4+Z6S9KQhGlyuzaxfznRVd8i+M79ex0KxpgrBOklhCv/LcL67uMxcATUvyaMu0PPcwmX8+Tq4yAQBDTKuKfrfILh8SxCQEAJgio7MHv3Lwh2yKpgU4JHlIK7HyDS6LEZAT2HHNV9Lx6eIZNhJwhij63ovxXzYvtc2AiCiK3tv2NgkY3BQpAn/+m/Y0jyfxDQM3L9qSS4eTmYCHLy3wHoxcLLKoKgKDfpv1VZ6FeDluCRrdmBOvHsiCXIU3dDAELcULcgNQRV+f8lOFNZYQhib+v+pbwYTnDeZg/Mxc5QgmbLNTgVVyEoCJo9pqCXp0BYEpz3GoFWilFYEMT7rIFBbLEc5wTVflPQy5tvyhlBjrHEgpeHViXHWK8yNxEcQ0T3YfPMH5TSR+43KcCFHRQe9QRBBv4xLHlOz1zq1+D142aBlqAAbwNvceYHMXgCWaEjuIC/wVU2/gJ2Z8qpvzAhoND+iav2OHL4WpiM4IQAfBrwpxJAbmXoLE5PiDdBDm0urhoAadDBP+K9JUeCIAHPot7xDKD2TCTjfhgJIii+qzxjXyqg25lFc4IAvp1PBoITeDGyYRAGAviBFBoAHAdsVMcj6kVAwQeS2xgJ7mCr6tEPArhfpt2KvSKwWR0sY0/wgJ9Inin+cRwf7t+EjwkBnNxGgPAvePQmCFJwMxvBE+HjpcFIUCE8M+4bCTBOHqtGggwRIPHISIAJNUQ2ENADvJXC1fwQfDdKHeiLAGyQWxmNMm44e9NMsK28zEhAMNFGNw2SgGIascKcFsoLzIBy2hH4iBDB4BsMuiJG1PM7AkwTy15shbCK3Q8iDk3gLZYRz1KoqCuhkuCEmjjzudQKtbPYSRJgRo0I89ncqsHsLDmrBGdDCLMlzB+o4N+9S4IalbNitkEAu8udRO0QCncNegTzuYBNP4SUwH3Ll0rTYqyweVhxIhdszsR4ND3RX7sQH92mMBCgtmL3NZ+g80Zy+eoFjlhGgpg02DbiZiDAWPhObkPQbQgzEKA/Jq7khm5U6sO2I/pKQtwI5lzqZdgM6IUozyaCcNQHhboLE4zXPyglSJPYSusuIwKfUSv6J4uM4LgKVn5tRRv3ppqH4LbmYihcsw56/24hjL/5VrpiL5DWlqoIVmXlkxX2YFMCaQ/wNnFbgiv+XNiWwD3jz8ZtCeTZuK6dKmzAZCHeX/LxPlLXTpVWpau+dMH7iXLuNK7is8SvKeknIn1l13OTuy6VdLkn8v9R35O+MiJeEEwkTXU0VVTQY9UkAl650cYL4JjJLdPYUlLyUh6l0PnoYiZQ3Cg8UZgy2nOdCgG6feviRkDsLHjtQ4u8BgV+ze0MXexszx+wGlxk9sFQ2W8Au/yBzcN2PXvOQCffsjP6HIrlXPfOa37/OA5n88d9ay7NNZYSQXQJDcPwyqUZ8oluDavwM+lRaxGGfKLey1f7g1jp/ccxp6rLK4t6CwCJoDO7Y15ZNw0exgaZdFIvx3duXXOyC1OYjtNd+RMn9wvqaEvphqyT+idO7ljU4RbXFrOhdVR+f3LPpL5r25vg465NeTmzM8FQAWC4c92ZYHbnqspE7kswv3dW3b3vTDC/e1eY5l0JlvUHihqMPQlUNRhOPh+EPQmYog5luSN3JFDX4izqkfYcA3U90rwwbz+Cj/I8Q13abgRcW5c2q83bi8BUm+c80smWZDndStN9JtJP33Neozl12PoKzC00XWDmGs0fqFP9gVrdH6hXlgjfrtnecRSgdes/ULv/A+8X5KY8fPkNxw+8Y/mBtzw/8J7J2fBNF1n3pstp37UBEnI2Cbb+XZvz/bd9zg+8b5SiMf/qG8+OoUi/+s611bff+rb69nvnTl9+8/2CsL57Z3u+e39BfPft/xtj9vcPzuv//sEfFSxPnb+gvH0AAAAASUVORK5CYII="
                  alt="user-img"
                  width="40"
                  height="40"
                  class="rounded-full shadow-md cursor-pointer block"
                /> -->
              </div>
              <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 9rem">
                  <!--li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/pages/profile')"
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Profile</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/email')"
                >
                  <feather-icon icon="MailIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Inbox</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/todo')"
                >
                  <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Tasks</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/chat')"
                >
                  <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Chat</span>
                </li>
                <vs-divider class="m-1"></vs-divider-->
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="logout()"
                  >
                    <feather-icon
                      icon="LogOutIcon"
                      svgClasses="w-4 h-4"
                    ></feather-icon>
                    <span class="ml-2">Logout</span>
                  </li>
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  >
                    <a
                      href="http://evosolucoes.com/evoOS/client/evo/"
                      target="_blank"
                      class="hover:bg-primary hover:text-white linkmenu"
                    >
                      <feather-icon
                        icon="HelpCircleIcon"
                        svgClasses="w-4 h-4"
                      />
                      <span class="ml-2">Help Desk</span></a
                    >
                  </li>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </vs-navbar>
    </div>

    <!-- START Modal Seleção de Empresas -->
    <vs-popup title="Lista de Empresas" :active.sync="isModalOpenChangeEmpresa">
      <div class="p-1">
        <h5 class="mb-3">Selecione a empresa desejada:</h5>
        <ul>
          <li
            class="p-3 m-1 itemList"
            v-for="(empresa, index) of listEmpresa"
            :key="index"
            :class="
              empresa.id_empresa == idEmpresaCurrent ? 'itemSelected' : null
            "
          >
            <vs-radio
              v-model="selectedOption"
              @change="selectedEmpresa(empresa.id_empresa)"
              :vs-value="empresa.id_empresa"
              >{{ empresa.nome }}
            </vs-radio>
          </li>
        </ul>
      </div></vs-popup
    >
    <!-- END Modal Seleção de Empresas -->
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import draggable from 'vuedraggable';
import jwt from 'jsonwebtoken';
import service from './../../services';
import functions from '../../utils/functions';

export default {
  name: 'the-navbar',
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: '',
      showFullSearch: false,
      decoded: {},
      unreadNotifications: [
        {
          index: 0,
          title: 'New Message',
          msg: 'Are your going to meet me tonight?',
          icon: 'MessageSquareIcon',
          time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)',
          category: 'primary',
        },
        {
          index: 1,
          title: 'New Order Recieved',
          msg: 'You got new order of goods.',
          icon: 'PackageIcon',
          time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)',
          category: 'success',
        },
        {
          index: 2,
          title: 'Server Limit Reached!',
          msg: 'Server have 99% CPU usage.',
          icon: 'AlertOctagonIcon',
          time: 'Thu Jan 31 2019 07:45:23 GMT+0000 (GMT)',
          category: 'danger',
        },
        {
          index: 3,
          title: 'New Mail From Peter',
          msg: 'Cake sesame snaps cupcake',
          icon: 'MailIcon',
          time: 'Fri Feb 01 2019 07:45:23 GMT+0000 (GMT)',
          category: 'primary',
        },
        {
          index: 4,
          title: "Bruce's Party",
          msg: 'Chocolate cake oat cake tiramisu',
          icon: 'CalendarIcon',
          time: 'Fri Feb 02 2019 07:45:23 GMT+0000 (GMT)',
          category: 'warning',
        },
      ],

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      isModalOpenChangeEmpresa: false,
      selectedOption: null,
      corEmpresa: null,
      notificationCount: 0,
      notificationsVisible: false,
      atualizationNotes: {},
      functions,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
    idEmpresaCurrent() {
      this.buscaConfigEmpresa();
    },
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == 'default') return 'navbar-default';
      else if (this.sidebarWidth == 'reduced') return 'navbar-reduced';
      else if (this.sidebarWidth) return 'navbar-full';
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesLimited', list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesMore', list);
      },
    },

    // PROFILEpreencheDados
    // user_displayName() {
    //   return this.decoded.nome;
    //   // return JSON.parse(localStorage.getItem('userInfo')).displayName
    // },
    activeUserImg() {
      if (localStorage.getItem('userInfo')) {
        return (
          JSON.parse(localStorage.getItem('userInfo')).photoURL ||
          this.$store.state.AppActiveUser.img
        );
      } else {
        return 'avatar-s-11.png';
      }
    },

    logo: {
      get() {
        return this.$store.state.logo;
      },
      set(value) {
        this.$store.dispatch('updateLogo', value);
      },
    },
    listEmpresa: {
      get() {
        return this.$store.state.listEmpresa;
      },
    },
    idEmpresaCurrent() {
      return this.$store.state.currentEmpresa;
    },
  },
  mounted() {
    this.getNotificationNotes();
    this.preencheDados();
    this.getNomeCurrentEmpresa();
    this.buscaConfigEmpresa();
    document.addEventListener('click', this.closeNotificationsOnOutsideClick);
    document.addEventListener(
      'endpointChange',
      this.closeNotificationsOnEndpointChange,
    );
  },
  beforeDestroy() {
    document.removeEventListener(
      'click',
      this.closeNotificationsOnOutsideClick,
    );
    document.removeEventListener(
      'endpointChange',
      this.closeNotificationsOnEndpointChange,
    );
  },
  methods: {
    logout() {
      localStorage.removeItem('user-token');
      localStorage.removeItem('p');
      localStorage.removeItem('listEmpresas');
      localStorage.removeItem('rotaEntrada');
      this.$router.push('/Login');
    },
    preencheDados() {
      const token = localStorage.getItem('user-token');
      this.decoded = jwt.decode(token);
      this.logo = localStorage.getItem('logo');
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch('updateStarredPage', {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : 'just now');
      }

      return 'Just Now';
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
    selectedEmpresa(value) {
      const empresa = this.listEmpresa.find((x) => x.id_empresa === +value);

      if (empresa) {
        this.isModalOpenChangeEmpresa = false;
        this.$store.dispatch('updateSelectedEmpresa', empresa);
        this.$router.push('/login-empresa');
      }
    },
    getNomeCurrentEmpresa() {
      const empresaSelecionada = this.listEmpresa.find(
        (empresa) => empresa.id_empresa == this.idEmpresaCurrent,
      );
      this.selectEmpresa = empresaSelecionada.id_empresa;
      this.selectedOption = empresaSelecionada.id_empresa;

      return empresaSelecionada.nome;
    },
    buscaConfigEmpresa() {
      try {
        service
          .getAll('g', {}, 'empresas/list/idEmpresa/' + this.idEmpresaCurrent)
          .then((res) => {
            let cores = res.data[0].temaCor;
            cores = JSON.parse(cores);
            this.corEmpresa = cores;
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Não foi possível buscar as configurações da empresa, tente novamente.'`,
          color: 'danger',
        });
      }
    },

    verificaBemProtege() {
      const token = localStorage.getItem('user-token');
      if (!token) {
        this.buscaDadosToImpressao();
        return;
      }
      let decoded = null;
      if (token) {
        decoded = jwt.decode(token);
      }
      const idEmpresa = decoded.id_empresa;
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },

    async getNotificationNotes() {
      try {
        const res = await service.getAll('notas-atualizacao', {}, 'obterNotas');

        const newNotifications = res.data.filter((note) => {
          return !this.getStoredNotificationIds().includes(note.idNota);
        });
        console.log(newNotifications);

        const updatedIds = [
          ...this.getStoredNotificationIds(),
          ...newNotifications.map((note) => note.idNota),
        ];
        this.updateStoredNotificationIds(updatedIds);

        this.notificationCount = newNotifications.length;
        this.atualizationNotes = res.data.map((note) => ({
          ...note,
          isCollapsed: false,
        }));
      } catch (error) {
        throw new Error(error);
      }
    },
    getStoredNotificationIds() {
      const storedIds = localStorage.getItem('notificationIds');
      return storedIds ? JSON.parse(storedIds) : [];
    },
    updateStoredNotificationIds(newIds) {
      localStorage.setItem('notificationIds', JSON.stringify(newIds));
    },

    closeNotificationsOnOutsideClick(event) {
      var targetElement = event.target;
      if (!targetElement.closest('.dropdown') && this.notificationsVisible) {
        this.notificationsVisible = false;
        this.resetNumberNotifications();
      }
    },

    closeNotificationsOnEndpointChange(event) {
      if (event.detail && event.detail.endpoint !== 'dashBoard') {
        this.notificationsVisible = false;
        this.resetNumberNotifications();
      }
    },
    showNotifications() {
      this.notificationsVisible = !this.notificationsVisible;

      if (!this.notificationsVisible) {
        this.resetNumberNotifications();
      }
    },

    resetNumberNotifications() {
      this.notificationCount = 0;
    },

    toggleCollapse(index) {
      this.$set(this.atualizationNotes, index, {
        ...this.atualizationNotes[index],
        isCollapsed: !this.atualizationNotes[index].isCollapsed,
      });
    },
    decreaseThreeHours(index) {
      const dataObj = new Date(index);
      dataObj.setHours(dataObj.getHours() - 3);
      return functions.formataDataISO8601(dataObj.toISOString());
    },
  },

  directives: {
    'click-outside': {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener('click', handler);
      },

      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    draggable,
  },
};
</script>
<style lang="scss" scoped>
.profile_and_notification {
  width: auto, 196px;
  height: auto, 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

@media (max-width: 390px) {
  .profile_and_notification {
    gap: 1px;
  }
}

@media (max-width: 430px) {
  .profile_and_notification {
    gap: 1px;
  }
}

.fab_with_Badge {
  width: fixed, 41px;
  height: fixed, 32px;
  position: relative;
}

.notification {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  padding: 6px;
  align-items: center;
  border-radius: 24px;
  background: var(--Neutral, #828382);
  cursor: pointer;
}

.badge {
  display: flex;
  padding: 1px 3px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--Danger, #ff4757);
  position: absolute;
  top: 0;
  left: 11px;
}

.content {
  position: relative;
  top: 0;
  right: 0;
  display: flex;
  padding: 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.number-notification {
  width: 7px;
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 11px; /* 110% */
}

.number-notification-dropdown {
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 11px; /* 110% */
}
.dropdown {
  display: inline-flex;
  padding: 8px 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: var(--White, #fff);
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (max-width: 390px) {
  .dropdown {
    width: 95%;
    position: fixed;
    top: 65px;
    left: 10px;
  }

  .mobile-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .text-Text-Variant {
    font-size: 14px;
  }

  .text-Text {
    font-size: 12px;
  }
}

@media (max-width: 430px) {
  .dropdown {
    width: 95%;
    position: fixed;
    top: 65px;
    left: 10px;
  }

  .mobile-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .text-Text-Variant {
    font-size: 14px;
  }

  .text-Text {
    font-size: 12px;
  }
}

.drop-notificacoes {
  display: flex;
  width: 400px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--Primary, #1f74ff);
  background: var(--White, #fff);
}
@media (max-width: 390px) {
  .drop-notificacoes {
    width: 100%;
  }
}
.drop-atualizacoes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 0px solid var(--BG-Variant, #f2f2f2);
}

.drop-atualizacoes-informations {
  display: flex;
  width: 400px;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--BG-Variant, #f2f2f2);
  background: var(--White, #fff);
}

.badge-dropdown {
  display: flex;
  padding: 0px 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--Danger, #ff4757);
}

.badge-dropdown-content {
  display: flex;
  padding: 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.collapse-notes {
  display: flex;
  width: 400px;
  padding: 16px;
  align-items: center;
  gap: 10px;
  background: var(--BG-Variant, #f2f2f2);
}

.text-collapse-notes {
  color: var(--Text-Variant, #4c4c4c);
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.collapse-div {
  align-items: center;
}

.link-help {
  color: #333 !important;
  span.text {
    margin: 2px 0 0 5px;
    float: right;
  }
}
.linkmenu {
  color: #666 !important;
  :hover {
    color: #fff !important;
  }
}

.selectEmpresa {
  margin-left: 12px;
  select {
    // Additional resets for further consistency
    background-color: transparent;
    border: none;
    padding: 0 1em 0 0;
    margin: 0;
    width: 100%;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
  }
}

.changeEmpresa {
  margin-left: 3rem;
  border-radius: 10px;
  background: #373737;
  color: white;
  padding: 0.5rem 1.5rem;
  display: flex;
  align-items: center;
  border: 1px solid #e6e6e6;
  gap: 1rem;
  cursor: pointer;

  button {
    background: #ffa857;
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
  }
}

.itemList {
  background: #e6e6e6;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.itemSelected {
  background: #cce5ff !important;
}

/* Estilos para dispositivos móveis */
@media (max-width: 500px) {
  .changeEmpresa {
    max-width: 60%; /* Define uma largura máxima para a div */
  }

  .changeEmpresa > div {
    white-space: nowrap; /* Impede a quebra de linha do conteúdo interno */
    overflow: hidden; /* Oculta qualquer conteúdo que exceda o tamanho da div */
    text-overflow: ellipsis; /* Adiciona reticências quando o texto é truncado */
  }

  .colorBlue {
    display: inline-block; /* Permite que a div se ajuste ao tamanho do span */
    max-width: 100%; /* Define uma largura máxima para o span */
  }
}
</style>
<style>
.collapse-div .vs-icon {
  background-color: #1f74ff;
  border-radius: 100%;
  color: #ffff;
}
.collapse-div .vs-collapse-item--content {
  background: var(--BG-Variant, #f2f2f2);
}
.collapse-div .con-content--item {
  overflow-y: auto;
  max-height: 50vh;
}
</style>
